import React, { useState } from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import General from "../../stores/GeneralStore";
import User from "../../stores/UserStore";
import deviceInfo from "../../utils/deviceInfo";
import { text } from "stream/consumers";
interface ConsentModalProps {
  gdpMatter: string;
  openState: boolean;
}

const ConsentModal: React.FC<ConsentModalProps> = ({gdpMatter ,openState}) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(openState);
  const [deviceData, setDeviceData] = useState<any>(null);
 const handleClose = () => setOpen(true);

  React.useEffect(() => {
    const fetchDeviceInfo = async () => {
      const data = await deviceInfo();
      setDeviceData(data);
    };
    fetchDeviceInfo();
  }, []);

  const handleSubmit = () => {
    setOpen(false);
    // Handle form submission
    const data = {
      deviceVersion: deviceData.device,
      location: deviceData.ip,
      browser: deviceData.platform,
      personId: User.profile.personId,
      fullName: User.profile.name??"",
      email: User.profile.email?? "",
      contactNo: User.profile.mobileNumber??"",
      referenceId: "",
      modeOfConsent: "CSS_LOGIN",
    }
    User.postDataConsent({ errorId: "consenterror", data });
    // console.log("post data",data);
  }
    
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: "90%", // mobile
      sm: "90%", // tablet
      md: "900px", // desktop
    },
    bgcolor: "background.paper",
    border: "1px solid #999",
    boxShadow: 24,
    padding: "15px",
    p: 4,
   
    maxHeight: {
      xs: "90vh", // mobile
      sm: "90vh", // tablet
      md: "95vh", // desktop
    },
    overflow: "auto",
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ padding: "15px", border: "1px solid #999", }}
    >
      <Box sx={style}>
        <Box sx={{ border: "1px solid #999", padding: "15px" }}>
          {/* Header Section */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <Box sx={{ 
              display: "flex", 
              alignItems: "center",
              justifyContent: { xs: "center", md: "space-between" },
              flexDirection: { xs: "column", md: "row" },
              width: "100%",
              gap: { xs: 2, md: 0 }
            }}>
              <Typography variant="h6" sx={{ 
              display: "flex",
              order: { xs: 1, md: 0 }
              }}>
              <img
                onClick={() => navigate(`${User.info.personId ? "/dashboard" : "/"}`)}
                src={logo}
                alt="Logo"
                style={{ height: "29px", width: "126px" }}
              />
              </Typography>
              <Typography 
              id="modal-modal-title" 
              variant="h6" 
              component="h2" 
              sx={{ 
                color: "#333333",
                fontWeight: "bold",
                lineHeight: { xs: "1.2", md: "1.5" },
                fontSize: { xs: "16px", sm: "18px", md: "18px" },
                textAlign: "center",
                width: "100%",
                order: { xs: 0, md: 1 },
                py: { xs: 1, md: 2 }
              }}
              >
              {General?.codeLabels["cm_consent_heading"]?.label}
              </Typography>
              <Typography 
              variant="subtitle1" 
              sx={{
                display: "flex",
                alignItems: "flex-end",
                minWidth: "140px",
                fontWeight: "bold",
                lineHeight: "1.5px",
                fontSize: { xs: "14px", md: "16px" },
                order: { xs: 2, md: 2 },
                justifyContent: { xs: "center", md: "flex-end" }
              }}
              >
              {`${new Date().getDate()} ${new Date().toLocaleString("default", { month: "long" })} ${new Date().getFullYear()}`}
              </Typography>
            </Box>
           
          </Box>

          {/* Content Section */}
          <Box>
            <Typography id="modal-modal-description" sx={{ 
              mt: 2, 
              textAlign: "justify", 
              fontSize: "18px !important", 
              fontFamily: "'cairoregular' !important",
              '& a': { 
              textDecoration: "none !important",
              color: `#101e8e !important`
              }
            }}>
              <div
              dangerouslySetInnerHTML={{ __html: gdpMatter }} />
            </Typography>

            {/* User Info */}
            <Box sx={{ mt: 3 }}>
              {[
                { label: "Full Name", value: User.profile.name },
                { label: "Mobile", value: User.profile.mobileNumber },
                { label: "Email", value: User.profile.email },
                { label: "Date & Time", value: `${new Date().getDate()} ${new Date().toLocaleString("default", { month: "long" })} ${new Date().getFullYear()} ${new Date().toLocaleTimeString()}` },
              ].map((item, index) => (
                <Typography key={index} variant="body1" sx={{ mb: 1, display: "flex" }}>
                  <strong style={{ minWidth: "100px" }}>{item.label} </strong> : {item.value}
                </Typography>
              ))}

              {/* Action Button */}
              <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  sx={{
                    backgroundColor: General.contrast.contrastColor ? General.contrast.contrastColor : General?.ColorAss,
                    fontSize: "16px",
                  }}
                >
                  {General?.codeLabels["cm_accept"]?.label || "Accept"}
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConsentModal;



